export const reservationConversations = {
  tabs: {
    calls: "Połączenia",
    web: "Web",
    checkins: "Check-in",
    charges: "Opłaty",
    notes: "Notatki",
  },
  checkinBadge: {
    allCompleted: "Wszystkie check-in ukończone",
    manuallyResolved: "Końcowa wysyłka zrealizowana ręcznie przez operatora",
    progress: "{done}/{total} ukończonych check-in",
  },
  banners: {
    limitedMode:
      "Ta rezerwacja nie jest skonfigurowana do pełnego procesu. Dostępne są tylko WhatsApp i notatki wewnętrzne.",
    rejectedMode:
      "Prośba została odrzucona. Dostępne pozostają tylko WhatsApp i notatki wewnętrzne.",
    autoReplying: "Agent odpowiada automatycznie.",
  },
  search: {
    placeholder: "Szukaj po nazwisku, telefonie lub kodzie rezerwacji...",
  },
  list: {
    emptyTitle: "Nie ma jeszcze rozmów",
    emptyText:
      "Gdy gość napisze lub gdy wyślesz wiadomość, rozmowa pojawi się tutaj.",
    noResultsTitle: "Nie znaleziono rozmów",
    noResultsText: "Spróbuj innego nazwiska, telefonu lub kodu rezerwacji.",
    aiActiveTitle: "Agent AI aktywny",
    markAllRead: "Oznacz wszystkie jako przeczytane",
  },
  conversation: {
    windowTimer: "Okno wiadomości: pozostało {hours} h",
    copyPortalCopied: "Link skopiowany",
    copyPortalTooltip: "Kopiuj link do zarządzania",
    copiedShort: "Skopiowano",
    copyLinkShort: "Kopiuj link",
    dropToAttach: "Upuść, aby załączyć pliki",
    senderBot: "BOT / OBSŁUGA",
    senderGuest: "GOŚĆ",
    imageAlt: "Wysłany obraz",
    locationReceived: "Otrzymano lokalizację",
    viewFile: "Zobacz plik",
    notSent: "Niewysłane",
    sending: "Wysyłanie...",
    emptyTitle: "Nie ma jeszcze wiadomości",
    emptyText:
      "Rozpocznij rozmowę od szablonu albo poczekaj, aż gość napisze.",
  },
  mode: {
    ai: "AI",
    manual: "Ręczny",
    agentInactiveTooltip:
      "Agent AI nie jest aktywny dla tego obiektu. Włącz go w ustawieniach oferty, aby odpowiadał automatycznie.",
    agentInactiveChip: "Agent AI nieaktywny",
  },
  composer: {
    predefinedTitle: "Gotowe odpowiedzi",
    predefinedEmpty: "Nie znaleziono gotowych odpowiedzi",
    attachFile: "Załącz plik",
    inputPlaceholder: "Zacznij od /, aby wybrać gotową odpowiedź.",
    removeFile: "Usuń plik",
    fileFallback: "plik",
  },
  calls: {
    title: "Połączenia dotyczące tej rezerwacji",
    none: "Brak połączeń powiązanych z tą rezerwacją.",
    caller: "Dzwoniący",
    bookedFromCall: "Zarezerwowano podczas tego połączenia",
    pause: "Wstrzymaj",
    play: "Odtwórz",
    downloadMp3: "Pobierz MP3",
    noRecording: "Brak nagrania",
  },
  ota: {
    noData: "Brak danych rezerwacji do wczytania wiadomości OTA.",
  },
  checkins: {
    title: "Check-in dla rezerwacji",
  },
  charges: {
    title: "Opłaty rezerwacji",
    noData: "Brak danych rezerwacji do wczytania opłat.",
  },
  notes: {
    title: "Notatki wewnętrzne",
    noData: "Brak danych rezerwacji do wczytania notatek.",
  },
  time: {
    today: "Dziś {time}",
    yesterday: "Wczoraj {time}",
  },
  guestFallback: "Gość",
  webGuestFallback: "Gość",
  documentFallback: "Dokument",
  location: {
    openInMaps: "Otwórz w Google Maps",
    viewCoords: "Zobacz współrzędne ({lat}, {lng})",
  },
  delivery: {
    read: "Przeczytane",
    delivered: "Dostarczone",
    queued: "W kolejce",
    failed: "Nieudane",
    sent: "Wysłane",
  },
  errors: {
    genericSendFail: "Nie udało się wysłać tej wiadomości przez WhatsApp.",
  },
  failureShort: {
    paymentIssue: "problem z płatnością na koncie WhatsApp",
    cannotReceive: "ten numer nie może odbierać wiadomości WhatsApp",
    downloadFailed: "WhatsApp nie mógł pobrać pliku",
    templateMissingData: "brakuje danych szablonu",
    requirementsNotMet: "wiadomość nie spełnia wymagań WhatsApp",
  },
  failureTitle: {
    noWhatsapp: "Brak WhatsApp",
    invalidNumber: "Nieprawidłowy numer",
    notSent: "Niewysłane",
  },
  alerts: {
    paymentIssue: "Problem z płatnością w WhatsApp",
    whatsappUnavailable: "WhatsApp niedostępny",
    qualityReduced: "Obniżona jakość numeru",
  },
  toast: {
    reactivateNoConv: "Nie udało się zidentyfikować rozmowy do reaktywacji.",
    templateSent: "Szablon wysłany pomyślnie.",
    reactivateFail: "Nie udało się wysłać szablonu reaktywacji.",
    cannotSendWhatsappTitle: "Nie można wysłać przez WhatsApp",
    invalidPhoneDetail:
      "Telefon w tej rezerwacji ({phone}) nie jest prawidłowym numerem. Popraw go w \"Edytuj rezerwację\", aby napisać do gościa.",
    noPhoneDetail:
      "Ta rezerwacja nie ma numeru telefonu. Dodaj go w \"Edytuj rezerwację\", aby napisać do gościa.",
    sendErrorTitle: "Błąd wysyłki",
    sendErrorDetail: "Nie udało się wysłać wiadomości",
    errorTitle: "Błąd",
    copyLinkFail: "Nie udało się skopiować linku",
    agentInactiveTitle: "Agent AI nieaktywny",
    agentInactiveDetail:
      "Ten obiekt nie ma aktywnego Agenta AI. Włącz go w ustawieniach oferty.",
    noConvId: "Nie udało się zidentyfikować rozmowy",
    modeChangeFail: "Nie udało się zmienić trybu czatu",
    agentUnavailableTitle: "Agent AI niedostępny",
  },
};
